export default __webpack_public_path__ + "static/focusLeafDarkBg-453ef3c550643a3e8469a12ecd4d6e52.png";